import React, { useState } from 'react';
import './AccountDeletion.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';


const AccountDeletion = () => {
  const [formData, setFormData] = useState({
    email: '',
    companyName: '',
    reason: '',
    confirmation: false
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.confirmation) {
      alert('Please confirm that you understand the consequences of account deletion.');
      return;
    }
    
    setIsSubmitting(true);
    
    // In a real application, you would make an API call here
    // For demonstration, we'll simulate an API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      
      // Reset form after successful submission
      setFormData({
        email: '',
        companyName: '',
        reason: '',
        confirmation: false
      });
    }, 1500);
  };
  
  return (
 <main>
     <Header />
     <br/><br/>
         <div className="account-deletion">
      <div className="container">
        <header className="deletion-header">
          <h1>Account Deletion Request</h1>
          <p className="subtitle1">Request to delete your SellWise360 account and associated data</p>
        </header>
        
        {!isSubmitted ? (
          <div className="deletion-content">
            <section className="warning-section">
              <div className="warning-box">
                <h3>⚠️ Important Information Before Proceeding</h3>
                <p><strong>Account deletion is permanent and cannot be undone.</strong> Please review what will happen:</p>
                <ul>
                  <li>All your personal account information will be permanently deleted</li>
                  <li>Business data (inventory, sales records, customer information) will be anonymized or deleted according to your preference</li>
                  <li>You will lose access to all SellWise360 services immediately</li>
                  <li>Any active subscriptions will be cancelled</li>
                  <li>Historical reports and analytics will no longer be accessible</li>
                </ul>
                <p className="note">Note: We may retain certain information as required by law or for legitimate business purposes (such as financial transaction records for accounting purposes).</p>
              </div>
            </section>
            
            <section className="alternatives-section">
              <h3>Consider These Alternatives First</h3>
              <div className="alternatives-grid">
                <div className="alternative-card">
                  <h4>Export Your Data</h4>
                  <p>Download your business data before deletion. Contact support for assistance with data export.</p>
                </div>
                <div className="alternative-card">
                  <h4>Account Downgrade</h4>
                  <p>Downgrade to a free plan if cost is a concern, instead of complete deletion.</p>
                </div>
                <div className="alternative-card">
                  <h4>Temporary Deactivation</h4>
                  <p>Request temporary deactivation if you plan to return to SellWise360 in the future.</p>
                </div>
              </div>
            </section>
            
            <section className="deletion-form-section">
              <h3>Submit Deletion Request</h3>
              <p>Fill out the form below to initiate the account deletion process. We will verify your identity and process your request within 30 days as required by data protection regulations.</p>
              
              <form onSubmit={handleSubmit} className="deletion-form">
                <div className="form-group">
                  <label htmlFor="email">Account Email Address / Login Id *</label>
                  <input
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter the email / login id associated with your account"
                  />
                </div>
                
               
                
                <div className="form-group">
                  <label htmlFor="reason">Reason for Deletion (Optional)</label>
                  <select
                    id="reason"
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                  >
                    <option value="">Select a reason</option>
                    <option value="cost">Cost too high</option>
                    <option value="switching">Switching to another service</option>
                    <option value="features">Missing required features</option>
                    <option value="business-closed">Business closed/changed</option>
                    <option value="privacy">Privacy concerns</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                {formData.reason === 'other' && (
                  <div className="form-group">
                    <label htmlFor="otherReason">Please specify</label>
                    <textarea
                      id="otherReason"
                      name="otherReason"
                      rows="3"
                      placeholder="Please tell us more about your reason for leaving..."
                    />
                  </div>
                )}
                
                <div className="form-group checkbox-group">
                  <input
                    type="checkbox"
                    id="confirmation"
                    name="confirmation"
                    checked={formData.confirmation}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="confirmation">
                    I understand that account deletion is permanent and irreversible. I have exported any data I wish to keep, and I confirm that I want to proceed with deleting my SellWise360 account and associated data.
                  </label>
                </div>
                
                <div className="form-group checkbox-group">
                  <input
                    type="checkbox"
                    id="dataPreference"
                    name="dataPreference"
                  />
                  <label htmlFor="dataPreference">
                    I prefer that my business transaction data be anonymized rather than deleted (recommended for accounting integrity).
                  </label>
                </div>
                
                <div className="form-actions">
                  <button
                    type="button"
                    className="secondary-button1"
                    onClick={() => window.history.back()}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="cta-button delete-button"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Processing...' : 'Submit Deletion Request'}
                  </button>
                </div>
                
                <p className="form-note">
                  After submission, you will receive a confirmation email with further instructions. Our team will contact you to verify your identity before processing the deletion. This process complies with GDPR, CCPA, and other data protection regulations.
                </p>
              </form>
            </section>
            
            <section className="contact-section">
              <h3>Need Help or Have Questions?</h3>
              <p>Contact our support team before proceeding with account deletion:</p>
              <div className="contact-details">
                <p>📧 <a href="mailto:support@sellwise360.com">hello@sellwise360.com</a></p>
                <p>+234-8133694347, +46-769702095</p>
              </div>
            </section>
          </div>
        ) : (
          <div className="success-section">
            <div className="success-icon">✓</div>
            <h2>Deletion Request Received</h2>
            <p>Your account deletion request has been submitted successfully</p>
            
            
          </div>
        )}
      </div>
    </div>
      <Footer />
      </main>
    

   
  );
};

export default AccountDeletion;